import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Dropzone } from '@robocorp/components';
import { IconTrash } from '@robocorp/icons/iconic';
import { BytesToFileSize, FileList } from '~/components';

type Props = {
  setFiles: (files: File[]) => void;
  files: File[];
  process?: boolean;
};

const CreateWorkItemFile: FC<Props> = ({ files, setFiles, process }) => {
  const { t } = useTranslation();

  const onRemoveFile = (index: number) =>
    setFiles(files.filter((_, fileIndex) => index !== fileIndex));

  return (
    <>
      <Box>
        <Dropzone
          onDrop={setFiles}
          title={t('files.addMultiple')}
          dropTitle={t('files.dropTitle')}
          description={process ? t('files.processDescription') : t('files.workItemDescription')}
          multiple
        />
      </Box>

      {files.length > 0 && (
        <Box pt="$24">
          <FileList>
            {files.map((file, index) => (
              <FileList.File
                fileName={file.name}
                fileSize={<BytesToFileSize bytes={file.size} />}
                onClick={() => null}
              >
                <Button
                  icon={IconTrash}
                  onClick={() => onRemoveFile(index)}
                  variant="ghost"
                  aria-label="delete"
                />
              </FileList.File>
            ))}
          </FileList>
        </Box>
      )}
    </>
  );
};

export default CreateWorkItemFile;
